var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.results && !_vm.results.length)?_c('div',{staticClass:"no-results-container"},[_c('div',{staticClass:"no-results"},[_vm._v("\n    No Results\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dc0b8c6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/no-results.vue
// module id = 1476
// module chunks = 0